import { newsArticles } from "../../data/newsArticles";

const NewsCard = ({ news, index }) => {
  return (
    <div
      className="col-12 col-md-6 col-xl-4"
      data-aos="fade-up"
      data-aos-delay={index * 100}
    >
      <article className="card news-card border-0">
        <a
          href={news.link}
          target="_blank"
          rel="noopener noreferrer"
          className="news-card-media"
        >
          <img loading="lazy" decoding="async" src={news.image} alt={news.title} className="news-card-image" />
        </a>
        <div className="news-card-divider" />
        <div className="card-body news-card-body d-flex flex-column">
          <h3 className="news-card-title ff_s">{news.title}</h3>
          <p className="news-card-text ff_n">{news.desc}</p>
          <a
            href={news.link}
            target="_blank"
            rel="noopener noreferrer"
            className="news-card-link ff_n"
          >
            Read More
          </a>
        </div>
      </article>
    </div>
  );
};

const NewsComponent = () => {
  return (
    <section className="news-section">
      <div className="container news-shell">
        <div className="row justify-content-center text-center">
          <div className="col-lg-9">
            <p className="news-eyebrow ff_n">Media Coverage</p>
            <h2 className="news-title ff_s">
              Latest <span className="section-heading-accent">News</span>
            </h2>
            <p className="news-subtitle ff_n">
              Recent coverage, launch announcements, and partnership highlights
              from across HKI Media.
            </p>
            <div className="news-divider" />
          </div>
        </div>

        <div className="row g-4 news-grid">
          {newsArticles.map((news, index) => (
            <NewsCard key={news.link} news={news} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsComponent;
